import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { IHeaderParams } from 'ag-grid-enterprise';
import { MatIconModule } from "@angular/material/icon";
import { CommonModule } from '@angular/common';

export interface EditableColumnOption {
  name: string;
  field?: string;
  undefined?: boolean;
  ignored?: boolean;
  example?: string;
}

export interface EditableColumnHeaderComponentParams extends IHeaderParams {
  presetField: string | null;
  columnId: number;
}

@Component({
  selector: 'app-editable-column-header-component',
  imports: [FormsModule, MatFormFieldModule, MatSelectModule, MatIconModule, CommonModule],
  templateUrl: './editable-column-header-component.html',
  styleUrl: './editable-column-header-component.css',
})
export class EditableColumnHeaderComponent {
  private params!: EditableColumnHeaderComponentParams;
  selectedColumn!: EditableColumnOption | undefined;

  readonly UNDEFINED_OPTION: EditableColumnOption = { name: 'Non défini', undefined: true }
  readonly COLUMN_OPTIONS: EditableColumnOption[] = [
    { name: 'Colonne ignorée', ignored: true },
    { name: "Nom site", field: "site_name", example: "CI Aigueperse"},
    { name: "Réf. site", field: "site_reference", example: "FR-CS172833"},
    { name: "Adresse", field: "address", example: "32B Rue du Port 63000 Clermont-Ferrand"},                                                 
    { name: "Adresse - Numéro Rue", field: "address_street_number", example: "32"},
    { name: "Adresse - Complément de numéro", field: "address_street_number_complement", example: "B"},
    { name: "Adresse - Nom Rue", field: "address_street_name", example: "Rue du Port"},
    { name: "Adresse - Type de voie", field: "address_street_type", example: "Rue"},
    { name: "Adresse - Code RIVOLI", field: "address_street_code", example: "3545" },
    { name: "Adresse - Ligne 1", field: "address_line_1", example: "32B Rue du Port"},
    { name: "Adresse - Ligne 2", field: "address_line_2", example: "Batiment B Etage 1"},
    { name: "Adresse - Code postal", field: "address_zip_code", example: "63000"},
    { name: "Adresse - Commune", field: "address_city", example: "Clermont-Ferrand"},
    { name: "Adresse - Code INSEE", field: "address_city_code", example: "63113"},                  
    { name: "Adresse - Pays", field: "address_country", example: "France"},
    { name: "Coordonnées (WGS84)", field: "coordinates", example: "47.3648483, 3.4732747836"},
    { name: "Coordonnées - Latitude (WGS84)", field: "coordinates_latitude", example: "47.364838"},
    { name: "Coordonnées - Longitude (WGS84)", field: "coordinates_longitude", example: "3.47637843"},
    { name: "Code Immeuble", field: "fibre_building_code", example: "IMB/63113/C/T7N1"},
  ];

  agInit(params: EditableColumnHeaderComponentParams): void {
    this.params = params;
    this.refresh(this.params);
  }

  refresh(params: EditableColumnHeaderComponentParams): boolean {
    this.params = params;
    const setFieldByUser = this.COLUMN_OPTIONS.find(
      (columnOption: EditableColumnOption) => 
        columnOption.field === this.params.context.componentParent.columnFields[this.params.columnId]
    );
    if (setFieldByUser) {
      this.selectedColumn = setFieldByUser;
      return true;
    }

    const presetField = this.COLUMN_OPTIONS.find(
      (columnOption: EditableColumnOption) => columnOption.field === params.presetField
    );
    this.selectedColumn = presetField ?? this.UNDEFINED_OPTION;
    return true;
  }

  onSelectionChange(): void {
    this.params.context.componentParent.assignColumnToField(this.params.column.getColId(), this.selectedColumn?.field);
  }

  getOptions(): EditableColumnOption[] {
    let options = this.COLUMN_OPTIONS;
    if (this.selectedColumn?.undefined) {
      options = [this.UNDEFINED_OPTION, ...this.COLUMN_OPTIONS];
    }
    return options;
  }
}
